var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("generic-modal", {
    ref: "modal",
    attrs: {
      id: "upcoming-recipients-modal-" + _vm.automation.id,
      "modal-dialog-size": _vm.isRenewalAutomation ? "xxl" : "lg",
      "modal-dialog-scrollable": false,
    },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function () {
          return [
            _c("div", [
              _c(
                "h5",
                { staticClass: "bold" },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm.$t("automations.upcomingRecipients.modalTitle", {
                          daysNumber:
                            _vm.timeValue === 0 ? "30" : _vm.timeValue,
                          dateType:
                            _vm.timeValue === 1
                              ? _vm.dateType.slice(0, -1)
                              : _vm.dateType,
                        })
                      ) +
                      "\n        "
                  ),
                  _c("refresh-button", {
                    attrs: { loading: _vm.refreshing },
                    on: { refresh: _vm.refreshRecipients },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("p", { staticClass: "font-weight-normal" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.$t("automations.upcomingRecipients.modalSubtitle")
                    ) +
                    "\n      "
                ),
              ]),
            ]),
          ]
        },
        proxy: true,
      },
      {
        key: "body",
        fn: function () {
          return [
            _c("upcoming-recipients-table", {
              ref: "upcomingTable",
              attrs: {
                "campaign-id": _vm.actionArguments.campaignId,
                "automation-id": _vm.automation.id,
                "is-renewal-automation": _vm.isRenewalAutomation,
              },
              on: {
                "go-to-client": _vm.handleGoToClientApp,
                loading: function ($event) {
                  _vm.refreshing = $event
                },
              },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }